import ServicePageTemplate from '../services/ServicePageTemplate';
import { seoPageData } from '../../mocks/seoPages';
const HeatPumpInstallationPage = () => <ServicePageTemplate data={seoPageData['heat-pump-installation']} />;
export default HeatPumpInstallationPage;
